module.exports = __webpack_public_path__ + "img/rlr_logo.a1f67a9f.jpg";